var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1035,
    height: 245,
    viewBox: "0 0 1035 245",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1413.49 -98.4746C1320.37 -83.2763 1310.28 -144.948 1217.16 -129.75C1124.03 -114.551 1134.11 -52.8822 1040.97 -37.6863C947.841 -22.4904 937.765 -84.1597 844.631 -68.9638C751.497 -53.7679 761.583 7.90363 668.449 23.0995C575.325 38.2977 565.037 -23.4854 471.913 -8.28718C378.789 6.91106 388.865 68.5803 295.731 83.7762C202.596 98.9721 192.521 37.3028 99.387 52.4987C6.25285 67.6946 16.3386 129.366 -76.7956 144.562",
    stroke: "white",
    strokeOpacity: 0.14,
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1427.23 9.69249C1334.1 24.8907 1324.02 -36.7809 1230.89 -21.5826C1137.77 -6.38441 1147.84 55.2848 1054.71 70.4807C961.575 85.6766 951.5 24.0074 858.366 39.2033C765.232 54.3991 775.318 116.071 682.183 131.267C589.06 146.465 578.772 84.6816 485.648 99.8799C392.524 115.078 402.6 176.747 309.465 191.943C216.331 207.139 206.256 145.47 113.122 160.666C19.9877 175.862 30.0734 237.533 -63.0607 252.729",
    stroke: "white",
    strokeOpacity: 0.14,
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1440.95 117.894C1347.83 133.092 1337.74 71.4202 1244.62 86.6184C1151.5 101.817 1161.57 163.486 1068.44 178.682C975.304 193.878 965.228 132.208 872.094 147.404C778.96 162.6 789.046 224.272 695.912 239.468C602.788 254.666 592.5 192.883 499.376 208.081C406.253 223.279 416.328 284.948 323.194 300.144C230.06 315.34 219.984 253.671 126.85 268.867C33.716 284.063 43.8017 345.734 -49.3324 360.93",
    stroke: "white",
    strokeOpacity: 0.14,
    strokeWidth: 3,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg1);
export default __webpack_public_path__ + "static/media/bg_1.0d9721943a6fd4a7845d1372c21babcf.svg";
export { ForwardRef as ReactComponent };